import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import BlueImage from "../../assets/images/blue.jpeg";
import CandidateImage from "../../assets/images/New folder/slider2.jpg";
import CandidateImage1 from "../../assets/images/New folder/slider3.jpg";
const Silder = () => {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const sliders = [
    {
      id: 3,
      image: CandidateImage,
      background: "linear-gradient(135deg, #c4ecfb 0%,#9dbefd 100%)",
    },
    // {
    //   id: 2,
    //   discraption:
    //     "مرحبًا بكم في موقع الانتخابات الخاص بنا! هنا يمكنكم العثور على معلومات حول المرشحين وسياستهم، وكيفية التصويت.",
    //   background: "linear-gradient(135deg, #86c5fc 0%,#e8c3fd 100%)",
    // },
    {
      id: 1,
      image: CandidateImage1,
      background: "linear-gradient(135deg, #ebeee0 0%,#edadbf 100%)",
    },
  ];

  return (
    <Carousel activeIndex={index} onSelect={handleSelect} id="home-slider">
      {sliders.map((slider, index) => {
        return (
          <Carousel.Item
            interval={200000000}
            key={index}
            style={{
              background: slider.background,
            }}
            className="rounded mt-2"
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100%" }}
            >
              <img
                className={slider.image ? "d-block" : "d-none"}
                src={slider.image}
                style={{ width: "100%", height: "100%" }}
                alt="First slide"
              />
              {slider.discraption ? (
                <div className="text-center font-weight-bold p-2 w-75 mx-auto h4 lh-lg">
                  {slider.discraption}
                </div>
              ) : null}
            </div>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
};

export default Silder;
